<template>
  <div class="flex justify-center my-4 w-full h-96 animate-pulse">
    <div class="h-full bg-gray-200 w-full rounded"></div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonRewardImage',
};
</script>

<style scoped>
.bg-gray-200 {
  background-color: #e2e8f0;
}
</style>
